import { PriceDisplay } from "@ticketingplatform/api/dist/__generated__/globalTypes";
import { GetEvent } from "@ticketingplatform/api/dist/event/__generated__/queries";
import { Venue } from "@ticketingplatform/api/dist/venue/__generated__/fragments";

type GetEvent_event_ticketPools_nodes = NonNullable<
  NonNullable<NonNullable<GetEvent["event"]>["ticketPools"]>["nodes"][number]
>;

export const areFeesIncluded = (priceDisplay?: Venue["priceDisplay"]) =>
  priceDisplay === PriceDisplay.ALL_FEES;

export const getPriceToDisplay = (
  ticketPool: Pick<GetEvent_event_ticketPools_nodes, "price" | "priceWithFees">,
  priceDisplay?: Venue["priceDisplay"]
) => {
  const { priceWithFees, price } = ticketPool || {};

  return areFeesIncluded(priceDisplay) ? priceWithFees : price;
};
